import { useTranslation } from 'next-i18next'

import FaqItem from '~/landingV4/components/FaqItem'
import SectionContainer from '~/landingV4/components/SectionContainer'
import { faqs } from '~/landingV4/consts/faqs.const'

export default function FaqSection(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')

  return (
    <SectionContainer className="pb-16 pt-14 md:py-20">
      <div className="mx-auto flex w-full max-w-2xl flex-col">
        <h2 className="text-center text-h4 font-extrabold uppercase tracking-tight text-black-ink md:text-11">
          {t('v4.faq.title')}
        </h2>
        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((faq) => (
            <FaqItem
              answerKey={faq.answerKey}
              defaultExpanded={faq.defaultExpanded}
              key={faq.questionKey}
              questionKey={faq.questionKey}
            />
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}
